<template>
  <b-modal
    id="UsersAddToTagModal"
    :title="$t('users.add_branch')"
    size="xl"
    ok-variant="success"
    cancel-variant="danger"
    :ok-title="$t('general.save')"
    :cancel-title="$t('general.cancel')"
    centered
    no-close-on-backdrop
    @ok.prevent="saveClick"
    @cancel="$bvModal.hide('ClassInfoAddModal')"
  >
    <filters
      :search="true"
      :level="false"
      :gender="false"
      :level-options="option"
      @filtered-items="filtered"
    />
    <b-row>
      <b-col cols="12">
        <b-table
          hover
          show-empty
          responsive
          :items="GET_APPROVED_BRANCH.results"
          :fields="fields"
          :empty-text="$t('general.no_data_to_view')"
        >
          <!--
          sticky-header="300px"
          @scroll.native="handleScroll" -->
          <template #head()="{ label }">
            {{ $t(label) }}
          </template>
          <template #cell(phone_number)="data">
            <span class="text-nowrap">
              {{ data.value }}
            </span>
          </template>

          <template #cell(selected)="{ item }">
            <b-form-checkbox
              :checked="selected_rows.includes(item.id)"
              @change="selectionChange($event, item.id)"
            />
          </template>
        </b-table>
        <!-- pagination -->
        <!-- slot-scope="props" -->
        <template>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap">{{ $t("general.show_from") }}</span>
              <b-form-select
                v-model="params.page_size"
                :options="pageOptions"
                class="mx-1"
                @change="changePerPage"
              />
              <span class="text-nowrap">{{ $t("general.show_to") }}</span>
              <!-- из {{ props.total }} -->
            </div>
            <div>
              <b-pagination
                v-model="params.page"
                :total-rows="GET_APPROVED_BRANCH.count"
                :per-page="params.page_size"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @change="changePage"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </b-col>
    </b-row>
    <!-- <b-overlay
      :show="isBusy"
      no-wrap
      opacity="0.5"
    /> -->
  </b-modal>
</template>

<script>
import {
  BRow,
  BModal,
  BCol,
  BTable,
  BFormCheckbox,
  BFormSelect,
  BPagination,
  // BOverlay,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import filters from "@/components/filters.vue";
import toast from "@/mixins/toast";

export default {
  components: {
    BRow,
    BModal,
    BCol,
    // BOverlay,
    BTable,
    BFormCheckbox,
    filters,
    BFormSelect,
    BPagination,
  },
  directives: {
    Ripple,
  },
  mixins: [toast],
  props: {
    oneClass: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    defSelected: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      pageOptions: [3, 5, 10],
      params: {
        page_size: 10,
        page: 1,
      },
      selected_rows: [],
      isBusy: false,
      level: [],
      option: [
        { title: "Square" },
        { title: "Rectangle" },
        { title: "Rombo" },
        { title: "Romboid" },
      ],
      fields: [
        {
          label: "Название филиала",
          key: "title",
        },
        {
          label: "Лимит пользователей (Ед.)",
          key: "capacity",
        },
        // {
        //   label: 'Лимит памяти (GB)',
        //   key: 'storage',
        // },
        {
          label: "Дата создания",
          key: "access_start_date",
        },
        {
          label: "Дата окончения",
          key: "access_end_date",
        },
        {
          label: "general.select",
          key: "selected",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("branches", ["GET_APPROVED_BRANCH"]),
  },
  watch: {
    /* Optionally hide scrollbar when loading */
    isBusy(newVal, oldVal) {
      if (newVal !== oldVal) {
        const tableScrollBody = this.$refs["course-select-table"].$el;
        if (newVal === true) {
          tableScrollBody.classList.add("overflow-hidden");
        } else {
          tableScrollBody.classList.remove("overflow-hidden");
        }
      }
    },
    defSelected(val) {
      this.selected_rows = val;
    },
  },
  mounted() {
    this.FETCH_APPROVED_BRANCH_LIST(this.params).then(() => {
      this.selected_rows = this.defSelected;
    });
  },
  methods: {
    ...mapActions("branches", [
      "FETCH_APPROVED_BRANCH_LIST",
      "UPDATE_BRANCHES_GROUP",
    ]),
    saveClick() {
      this.UPDATE_BRANCHES_GROUP({
        id: this.$route.params.id,
        branch_ids: this.selected_rows,
      })
        .then(() => {
          this.$_successToast("Добавлено");
          this.$emit("refresh");
          this.$bvModal.hide("UsersAddToTagModal");
          this.refresh();
        })
        .catch(() => {
          this.$_errorToast(this.$t("general.error"));
        });
    },
    refresh() {
      this.FETCH_APPROVED_BRANCH_LIST(this.params).then(() => {
        this.selected_rows = this.defSelected;
      });
    },
    selectionChange(val, id) {
      // if (val) {
      //   if (this.selected_rows.includes(id)) {
      //     return
      //   }
      //   this.selected_rows.push(id)
      // }
      // this.selected_rows = this.selected_rows.filter(item => item !== id)
      const index_id = this.selected_rows.indexOf(id);
      if (val) this.selected_rows.push(id);
      else this.selected_rows.splice(index_id, 1);
    },
    filtered(val) {
      console.log(val);
      this.params = { ...this.params, ...val };
      this.FETCH_APPROVED_BRANCH_LIST(this.params);
    },
    changePerPage(size) {
      this.params.page_size = size;
      this.params.page = 1;
      this.FETCH_APPROVED_BRANCH_LIST(this.params);
    },
    changePage(value) {
      this.params.page = value;
      this.FETCH_APPROVED_BRANCH_LIST(this.params);
    },
    // handleScroll(e) {
    //   // console.log('hihi', e)
    //   if (
    //     e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight
    //   ) {
    //     if (!this.isBusy) {
    //       console.log('a')
    //     }
    //   }
    // },
  },
};
</script>

<style></style>
